import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {concatMap, defaultIfEmpty, take} from 'rxjs/operators';
import {MemberStateService} from '../../services/member-state.service';
import {AdmissibilityService} from '../../services/admissibility.service';
import {UserContextService} from '../../services/user-context.service';
import {EMPTY, Observable} from 'rxjs';
import {ViewState, toViewState} from '../../model/view-state';
import {Permits} from '../../model/permits';
import { TranslatePipe } from '@ngx-translate/core';
import { IntroductionComponent } from '../shared/introduction/introduction.component';
import { AlertComponent } from '../shared/alert/alert.component';
import { LoaderComponent } from '../shared/loader/loader.component';
import { PermitResidencesComponent } from './permit-residences/permit-residences.component';
import { PermitWorksComponent } from './permit-works/permit-works.component';

@Component({
    selector: 'myabvv-permits',
    standalone: true,
    templateUrl: './permits.component.html',
    styleUrls: ['./permits.component.css'],
    imports: [
      IntroductionComponent, AlertComponent, LoaderComponent, PermitResidencesComponent,
      PermitWorksComponent, TranslatePipe, AsyncPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PermitsComponent implements OnInit {
  private memberStateService = inject(MemberStateService);
  private admissibilityService = inject(AdmissibilityService);
  private userContext = inject(UserContextService);

  state$: Observable<ViewState<Permits | null>>;
  nationality: string;

  ngOnInit() {
    const isInternalUser = this.userContext.isInternalUser();

    // Use /me endpoint for external users, /{inss} for internal users
    const permits$ = isInternalUser
      ? this.memberStateService.getMember().pipe(
          take(1),
          concatMap(member => {
            if (this.nationality !== '150') {
              return this.admissibilityService.getPermits(member.personalInformation.inss);
            }
            return EMPTY;
          })
        )
      : this.admissibilityService.getMyPermits();

    this.state$ = permits$.pipe(
      defaultIfEmpty<Permits, Permits | null>(null),
      toViewState(err => +err.status !== 404)
    );
  }
}
